import { File, Download } from "lucide-react";
import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";

export default function DocumentMessage({ message }) {
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";

  const fileUrl = content.media?.link;
  const filename = content.media?.filename;

  if (!fileUrl) {
    return null;
  }

  const getFileIcon = () => {
    return <File className="h-5 w-5 text-gray-600 dark:text-slate-300 flex-shrink-0" />;
  };

  return (
    <MessageContainer isOutbound={isOutbound}>
      <a
        href={fileUrl}
        download={filename}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 py-2 px-1 hover:opacity-80 transition-opacity"
      >
        {getFileIcon()}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium truncate">{filename || "Document"}</div>
          <div className="text-xs text-gray-500 dark:text-slate-400">Click to download</div>
        </div>
        <Download className="h-4 w-4 text-gray-600 dark:text-slate-300 flex-shrink-0" />
      </a>
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} />
    </MessageContainer>
  );
}
